export const createFileGaClickEvent = (url: string) => {
    const split = url.split('/');
    const filename = split[split.length - 1];
    return {
        event: 'gaEvent',
        eventCategory: 'downloads',
        eventAction: 'direct download',
        eventLabel: filename,
    };
};
